//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { gql } from 'graphql-tag'
import { required, email, minLength, sameAs } from 'vuelidate/lib/validators'
import OtpInput from '@bachdgvn/vue-otp-input'

const RESEND_CONFIRMATION_CODE = gql`
  mutation ($email: String!, $isRegistrationCode: Boolean!) {
    resendConfirmationCode(email: $email, isRegistrationCode: $isRegistrationCode)
  }
`

const CONFIRM_CODE = gql`
  mutation ($email: String!, $code: String!) {
    confirmCode(email: $email, code: $code)
  }
`

const RESET_PASSWORD = gql`
  mutation ($data: ResetPasswordInput) {
    resetPassword(data: $data) {
      email
    }
  }
`

export default {
  components: {
    'v-otp-input': OtpInput
  },
  props: {
    isInline: {
      type: Boolean,
      default: true
    }
  },
  validations: {
    email: { required, email },
    code: { required, minLength: minLength(5) },
    passwordForm: {
      password: { required, minLength: minLength(6) },
      repeatPassword: { required, sameAsPassword: sameAs('password') }
    }
  },
  data() {
    return {
      saving: false,
      currentState: null,
      success: false,
      submitted: false,
      error: null,
      formState: {
        ENTER_EMAIL: 1,
        ENTER_CODE: 2,
        ENTER_PASSWORD: 3
      },
      email: '',
      code: '',
      passwordForm: {
        password: '',
        repeatPassword: ''
      },
      canResend: true,
      timer: '05:00'
    }
  },
  computed: {
    currentBreakPoint() {
      return this.$store.get('app/currentBreakPoint') || 'md'
    }
  },
  mounted() {
    this.currentState = this.formState.ENTER_EMAIL
  },
  methods: {
    handleOnComplete(value) {
      this.$v.code.$model = value
      this.onConfirmCode()
    },
    handleOnChange(value) {
      this.$v.code.$model = value
    },
    redirectToLogin() {
      this.$nuxt.$emit('toggleConfirmAccountModal', { isShow: false })

      this.$router.push({ path: '/login' })
    },
    async onConfirmCode() {
      try {
        this.$v.code.$touch()
        if (this.$v.code.$invalid) {
          this.$nextTick(() => {
            const el = document.querySelector('#forgot-form-code-container input.is-danger')
            if (el) el.focus()
          })
          return false
        }

        this.saving = true

        const { data } = await this.$apollo.mutate({
          mutation: CONFIRM_CODE,
          variables: {
            email: this.email,
            code: this.code
          }
        })

        const { confirmCode } = data
        if (confirmCode) {
          this.currentState = this.formState.ENTER_PASSWORD
          this.error = null
        }
      } catch (error) {
        this.error = this.handleError(error)
      } finally {
        this.saving = false
      }
    },
    async onResetPassword() {
      try {
        this.$v.passwordForm.$touch()
        if (this.$v.passwordForm.$invalid) {
          this.$nextTick(() => {
            const el = document.querySelector('#forgot-form-password-container input.is-danger')
            if (el) el.focus()
          })
          return false
        }

        this.saving = true

        const { data } = await this.$apollo.mutate({
          mutation: RESET_PASSWORD,
          variables: {
            data: {
              email: this.email,
              password: this.passwordForm.password
            }
          }
        })

        const { resetPassword } = data
        const hasKeys = Object.keys(resetPassword).length
        if (hasKeys) {
          this.error = null
          await this.$auth.login(
            'password',
            {
              username: this.email,
              password: this.passwordForm.password
            },
            true
          )
        }
      } catch (error) {
        this.error = this.handleError(error)
      } finally {
        this.saving = false
      }
    },
    async resendEmail() {
      try {
        await this.$apollo.mutate({
          mutation: RESEND_CONFIRMATION_CODE,
          variables: {
            email: this.email,
            isRegistrationCode: false
          }
        })

        this.resendConfirmationCodeTimer()
      } catch (error) {
        this.error = error.message
      } finally {
        this.canResend = false
      }
    },

    resendConfirmationCodeTimer() {
      let minute = 5
      let sec = 0

      const timerInterval = () => {
        this.timer = String(minute).padStart(2, '0') + ':' + String(sec).padStart(2, '0')
        if (sec === 0) {
          if (minute === 0) {
            this.canResend = true
            clearInterval(timerInterval)
          } else {
            minute--
            sec = 59
          }
        } else {
          sec--
        }
      }

      setInterval(timerInterval, 1000)
    },
    async onSendCode() {
      try {
        this.$v.email.$touch()
        if (this.$v.email.$invalid) {
          this.$nextTick(() => {
            const el = document.querySelector('#forgot-form-email-container input.is-danger')
            if (el) el.focus()
          })
          return false
        }

        this.saving = true

        const { data } = await this.$apollo.mutate({
          mutation: RESEND_CONFIRMATION_CODE,
          variables: {
            email: this.email,
            isRegistrationCode: false
          }
        })

        const { resendConfirmationCode } = data
        if (resendConfirmationCode) {
          this.currentState = this.formState.ENTER_CODE
          this.error = null
        }
      } catch (error) {
        this.error = this.handleError(error)
      } finally {
        this.saving = false
      }
    }
  }
}
